export default {
  Global: {
    MAYDAY: 'Mayday',
    RECHARGER: 'Recharger',
    BALANCER: 'Balancer',
    BRAG: 'BRAG',
    PLATFORM: 'Platform',
    FIXER: 'Fixer',
    CANCEL: 'Cancel',
    CONFIRM: 'Confirm',
    SEARCH: 'Search',
    FROM: 'From',
    TO: 'To',
    IN: 'In',
    DATE: 'Date',
    SOURCE: 'Source',
    DESCRIPTION: 'Description',
    REFERENCE: 'Reference',
    ACCOUNT: 'Account',
    NOMINAL_CODE: 'Account Code',
    TRACKING_CATEGORY: 'Tracking Category',
    RECHARGE_RULE: 'Recharge Rule',
    MONTH: 'Month',
    PERIOD: 'Period',
    INVOICES: 'Invoices',
    POSTINGS: 'Postings',
    EMAIL: 'Email address',
    DELETE: 'Delete',
    ARCHIVE: 'Archive',
    RESTORE: 'Restore',
    EDIT: 'Edit',
    SAVE: 'Save',
    TOTAL: 'Total',
    DETAILS: 'Details',
    DEFAULT_RULE: "Don't recharge",
    ENTITY: 'Entity',
    RECONNECT: 'Reconnect',
    LOADING: 'Loading',
    TRANSACTION_COUNT: ['{{count}} transaction', '{{count}} transactions'],
    NET: 'Net',
    DEPARTMENT: 'Department',
    COUNTRY: 'Country',
    CURRENCY: 'Currency',
    REVIEWED: 'Transactions Reviewed',
    POSTED: 'Posted to Xero',
    COMING_SOON: 'Coming soon',
    BACK: 'Go Back',
    AND: 'and',
    UPGRADE_TODAY: 'Upgrade today',
    GO_TO_BILLING: 'Go to Settings > Billing to upgrade your plan',
    CLEAR_SEARCH: 'Clear search',
    TYPE_TO_LOAD_MORE_OPTIONS: '... Type to load more options',
    UPDATE: 'Update in Xero',
    FILTERED: 'Filtered by',
    STATUS: 'Status',
    CUSTOM: 'Custom',
    ARCHIVED: 'archived',
    DEBIT: 'Debit',
    CREDIT: 'Credit',
    Fx: {
      MONTH: '{{month}}',
      ALL: 'All time',
    },
    Connect: {
      CONFLICT_TITLE: 'Organisation already connected',
      CONFLICT_BODY:
        'One or more Xero Organisations are already connected to Mayday',
    },
  },
};
